module.exports = __webpack_public_path__ + "img/p07.5dd85b05.jpg";